module.exports = __webpack_public_path__ + "static/media/download-icon.19ed8404.svg";